import React, { ReactElement, ReactNode, ReactChild } from 'react'
import Search from '@mindfulchefuk/components/Search'
import { CookieBanner } from '@mindfulchefuk/features/Cookies/components'
import QuickSearchCategories from '@mindfulchefuk/components/Recipes/QuickSearchCategories'

import quickSearchCategoriesConfig from '@mindfulchefuk/components/Recipes/QuickSearchCategories/quickSearchCategoriesConfig'

import { TFilterDefaults } from '@mindfulchefuk/components/Search/Filters/types'
import MainLayout from '@mindfulchefuk/layouts/MainLayout'
import {
  Box,
  colors,
  IllustrationContainer,
  space,
  typography,
} from '@mindfulchefuk/design-system'
import styled from '@emotion/styled'

// A lot of pages use this layout so still styling the headings as they were before to keep amount of changes low.
const ContainerWithTextStyles = styled(IllustrationContainer)`
  color: ${colors.aubergine};
  h1 {
    ${typography['heading-lg']};
    margin-bottom: ${space[16]};
  }

  h2 {
    ${typography['heading-md']};
    margin-bottom: ${space[16]};
  }

  h3 {
    ${typography['heading-sm']};
    margin-top: ${space[24]};
    margin-bottom: ${space[16]};
  }

  p,
  ul {
    ${typography['body-lg']};
    margin-top: 0;
    margin-bottom: ${space[16]};
  }

  li {
    margin-bottom: ${space[4]};
    list-style: disc inside none;
  }
`
type TRecipesSearchGetLayoutParams = {
  metaTitle?: string
  metaDescription?: string
  metaCanonicalPath?: string
}

export const recipesSearchGetLayout =
  ({
    metaTitle,
    metaDescription,
    metaCanonicalPath,
  }: TRecipesSearchGetLayoutParams = {}) =>
  (page: ReactChild): ReactElement =>
    (
      <MainLayout
        title={metaTitle}
        description={metaDescription}
        canonical={metaCanonicalPath}
      >
        {page}
      </MainLayout>
    )

type TRecipesSearchLayout = {
  mainSection: ReactNode
  secondarySection: ReactNode
  filterDefaults?: TFilterDefaults
}

const RecipesSearchLayout = ({
  mainSection,
  secondarySection,
  filterDefaults,
}: TRecipesSearchLayout): ReactElement => (
  <Box overflow="hidden">
    <ContainerWithTextStyles py={48} illustrations="07">
      <Box>{mainSection}</Box>
      <Search filterDefaults={filterDefaults} />
      <Box mb={32}>{secondarySection}</Box>
      <QuickSearchCategories categories={quickSearchCategoriesConfig} />
    </ContainerWithTextStyles>
    <CookieBanner />
  </Box>
)

export default RecipesSearchLayout
